<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
               <div class="flex xs12 sm2">
              <v-select
                :items="[{
                          text: '이름',
                          value: 'name'
                        },
                        {
                          text: '신고내용',
                          value: 'type'
                        },
                        {
                          text: '신고 처리 상태',
                          value: 'state'
                        }]"
                name="header"
                v-model="searchFormModel.filter"
                label="header"
              ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                <v-select
                        :items="state"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'type'">
                <v-select
                        :items="blameType"
                        v-model="searchFormModel.filterText"
                        label="선택"
                        item-text="text"
                        item-value="state"
                >
                </v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state' && searchFormModel.filter !== 'type'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">
                    <template v-if="props.item.relation.split('_')[0] === 'A'">
                        <a>관리자</a>
                    </template>
                    <template v-else>
                      <a @click="openDetail(props.item.relation.split('_')[0], props.item.reportUserId)">{{ (props.item.relation.split('_')[0] === 'D' ? '기사' : '승객') + ' ' + props.item.reportUserId }}</a>
                    </template>
                  </td>
                  <td class="text-sm-center">{{ props.item.blamedUserId }}</td>
                  <td class="text-sm-center">{{ props.item.passenger.personalInfo.name }}</td>
                  <td class="text-sm-center">{{ props.item.type }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">
                    <v-select
                      :items="state"
                      label="State"
                      item-text="text"
                      item-value="state"
                      single-line
                      :value="props.item.state"
                      @change="changeState(props.item.id, $event)">
                    </v-select>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/reportState';
import BlameType  from '@/api/blameType';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'name',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      prevData: null,
      complex: {
        headers: [
          {
            text: '신고 번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '신고자',
            value: 'reportUserId',
            align: 'center'
          },
          {
            text: '승객 고유번호',
            value: 'blamedUserId',
            align: 'center'
          },
          {
            text: '승객 이름',
            value: 'name',
            align: 'center'
          },
          {
            text: '신고내용',
            value: 'type',
            align: 'center'
          },
          {
            text: '신고일시',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '신고 처리 상태',
            value: 'state',
            align: 'center'
          },
        ],
        items: []
      },
      state: State,
      blameType: BlameType
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'PassengerReportPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    },
    'searchFormModel.filter' () {
        this.searchFormModel.filterText = '';
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'blamedPassengers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeState (id, state) {
      const prameters = {
        method: 'changeStateBlamedPassenger',
        'id': id,
        'state': state
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    openDetail (relation, id) {
      if (id != '0'){
        top.getApp.addPrevData('PassengerReportPage', this.pagination, this.searchFormModel);
        if (relation === 'D') {
          this.$router.push('/member/driverMemberDetail/' + id);
        }
        else {
          this.$router.push('/member/passengerMemberDetail/' + id);
        }
      }
    },
    searchFilter () {
      this.banbanCreated();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/report/PassengerReport.vue